import { TYPO3_BASE_URL } from "@/services/globals";
import { usePersistBoundStore } from "@/services/zustand/Store";

export const useLogoutUser = () => {
    const updateSessionToken = usePersistBoundStore.getState().updateSessionToken;
    const logoutUser = async () => {
        const result = await fetch(`${TYPO3_BASE_URL}auth/logout/`, {
            method: 'GET',
        });
        updateSessionToken(null);
    }
    return { logoutUser }
}